app.bind('default basic tabby', function (context) {
    $('[js-tabby-tab]', context).tabby();
});
